import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";

Scrivito.provideEditingConfig("Image", {
  attributes: localizeAttrList(["tags", "title", "alternativeText"], "Image"),
  properties: ["title", "description", "alternativeText", "tags"],
  validations: [
    [
      "title",
      (title) => {
        if (title === "") {
          return "No title is set for the image.";
        }
        return null;
      },
    ],
    [
      "alternativeText",
      (alternativeText) => {
        if (alternativeText === "") {
          return "An alternavtive text fro this image is not set.";
        }
        return null;
      },
    ],
  ],
});
